import React from "react";

const Scroll = (props) => {
  return <div className="scroll">{props.children}</div>;
};

export default Scroll;

// background: linear-gradient(to left, rgba(7,27,82,1) 0%, rgba(0,128,128,1) 100%);
